<template>
  <div class="page-content">
    <div class="page flex-col">
      <img class="img-div" src="../assets/images/shop/small-mall.png">
    </div>
  </div>
</template>

<script>
export default {
  name: "PointsMall",
  methods: {
    openRouter(){
      const { href } = this.$router.resolve({
        path: '/jlzc/dxzlzx/home',
      });
      window.open(href, '_blank', 'noopener');
    }
  }
}
</script>

<style scoped>
.page-content{
  min-height: calc(100vh - 80px);
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.page{
  width: 1220px;
}
.my-flex-row{
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: 20px;
}
  .searchjg {
    width: 100%;
    height: 150px;
    margin: 0px auto 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
  }
  .searchjg ul {
    list-style: none;
    width: 1200px;
    margin: 0 auto;
  }
  .search-dropdownbox {
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    width: 100%;
    z-index: 999;
    display: none;
    opacity: 1;
    -webkit-transition: opacity 0.2s ease-in-out;
    transition: opacity 0.2s ease-in-out;
  }
  .search-dropdownbox::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 20px;
    width: 0;
    height: 0;
    border-width: 0 8px 8px 8px;
    border-style: solid;
    border-color: transparent transparent #ffffff transparent;
    z-index: 1;
  }
  .search-dropdownbox::after {
    content: '';
    position: absolute;
    top: -7px;
    left: 20px;
    width: 0;
    height: 0;
    border-width: 0 8px 8px 8px;
    border-style: solid;
    border-color: transparent transparent #ffffff transparent;
    z-index: 9999;
  }
  .search-dropdown {
    position: absolute;
    top: -1px;
    left: 0;
    width: 540px;
    max-height: 140px;
    overflow-y: auto;
    background: #fff;
    -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    z-index: 999;
    border-radius: 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 5px;
    border: 5px solid #ffffff;
    /* Chrome/Safari/Edge */
    /* Firefox */
    scrollbar-width: none;
    /* IE/Edge æ—§ç‰ˆ */
    -ms-overflow-style: none;
  }
  .search-dropdown::-webkit-scrollbar {
    display: none;
  }
  .search-dropdown li:hover {
    background-color: #eaeaea;
  }
  .grsmzq-jg li span,
  .frsmzq-jg li span,
  .searchjg li span,
  .cy span {
    display: block;
    width: 240px;
    text-align: center;
    float: left;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    font-size: 22px;
    right: 10px;
  }
  .grsmzq-jg li,
  .frsmzq-jg li,
  .searchjg li,
  .cy {
    float: left;
    width: 435px;
    height: 130px;
    background: #FFFFFF;
    border-radius: 24px 24px 24px 24px;
    -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    margin-left: 30px;
    margin-top: -100px;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
  }
  .grsmzq-jg li a,
  .frsmzq-jg li a,
  .searchjg li a,
  .cy a {
    display: block;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }
  .grsmzq-jg li img,
  .frsmzq-jg li img,
  .searchjg li img,
  .cy img {
    width: 90px;
    height: 90px;
    float: left;
    margin: 20px 20px;
  }
  .grsmzq-jg li span,
  .frsmzq-jg li span,
  .searchjg li span,
  .cy span {
    display: block;
    width: 240px;
    text-align: center;
    float: left;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    font-size: 22px;
    right: 10px;
    color: #333;
  }
  .text-wrapper_1 {
    height: 28px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #0456AD;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

.box_1 {
  background-color: rgba(245, 245, 245, 1);
  margin-top: 65px;
}
.text-wrapper_1 {
  width: 145px;
  height: 28px;
  margin: 80px 0 0 0px;
}
.text_1 {
  width: 145px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(4, 86, 173, 1);
  font-size: 20px;
  font-family: PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}
.group_1 {
  width: 890px;
  height: 130px;
  margin: 20px 0 0 0px;
  display: flex;
  gap: 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-content: center;
  align-items: center;
}
.group_2 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 24px;
  width: 435px;
  height: 130px;
  display: flex;
  cursor: pointer;
}
.image_1 {
  width: 96px;
  height: 96px;
  margin: 17px 0 0 28px;
}
.text_2 {
  width: 200px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
  font-family: PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 51px 69px 0 42px;
}
.group_3 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 24px;
  width: 435px;
  height: 130px;
  display: flex;
}
.image_2 {
  width: 96px;
  height: 96px;
  margin: 17px 0 0 28px;
}
.text_3 {
  width: 220px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
  font-family: PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 51px 49px 0 42px;
}
.text-wrapper_2 {
  width: 145px;
  height: 28px;
  margin: 35px 0 0 0px;
}
.text_4 {
  width: 145px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(4, 86, 173, 1);
  font-size: 20px;
  font-family: PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}
.group_4 {
  width: 435px;
  height: 130px;
  margin: 20px 0 80px 0px;
}
.box_2 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 24px;
  width: 435px;
  height: 130px;
  display: flex;
}
.image_3 {
  width: 96px;
  height: 96px;
  margin: 17px 0 0 28px;
}
.text_5 {
  width: 167px;
  height: 28px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
  font-family: PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin: 51px 102px 0 42px;
}
</style>
